import client from "../libs/HttpClient";

class ManualService {
  static getManualData() {
    return client.get("/manuals");
  }
}

export { ManualService };
